import { Box, Button, Paper, Typography } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    LogoutAction,
    ResesndAction,
    SendActivationLink,
} from '../../Store/Actions/AuthActions'
import { useNavigate } from 'react-router-dom'

import buildBid from '../../Assets/Images/Build-BID2.png'
import buildVid from '../../Assets/Images/buildvids-logo.png'
import buildLink from '../../Assets/Images/BuildLinkCompleteLogo.png'
import linksurance from '../../Assets/Images/linksurance-logo.png'
import buildStudio from '../../Assets/Images/BuildStudiologo-gold.png'

const Verification = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        sendActivationLoading,
        sendActivationMessage,
        sendActivationError,
    } = useSelector((state) => state.SendActivationReducer)

    const { userLogindata } = useSelector((state) => state.LoginReducers)

    const sendActivation = () => {
        dispatch(SendActivationLink())
        if (userLogindata?.data?.login_first_time) {
            dispatch(LogoutAction(navigate, 'firstLogin'))
        } else {
            dispatch(LogoutAction(navigate))
        }
    }
    return (
        <Box
            component={Paper}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                boxShadow: 'none',
                // height: { xs: 'auto', lg: '100vh' },
                justifyContent: 'center',
                // width: { xs: '100%', lg: '60%' },
                // alignItems: { xs: 'center', lg: 'flex-start' },
                // padding: {
                //     xs: '2rem 1rem',
                //     sm: '3rem 2rem',
                //     md: '4rem 3rem',
                //     lg: '6.4rem',
                // },
                // backgroundColor: '#EFF5FD',
                // minHeight: { xs: '100vh', lg: 'auto' },
            }}
        >
            <Box
                sx={{
                    width: { xs: '100%' },
                    // maxWidth: '32rem',
                    margin: { xs: '0 auto', lg: '0' },
                    backgroundColor: { xs: 'white', md: 'transparent' },
                    padding: { xs: '2rem 1rem', md: '0' },
                    borderRadius: { xs: '20px' },
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        marginTop: { xs: 2, lg: 4 },
                        letterSpacing: '-0.025em',
                        lineHeight: 1.25,
                        fontWeight: 800,
                        fontSize: {
                            xs: '1.75rem',
                            sm: '2rem',
                            lg: '2.2rem',
                        },
                        textAlign: { xs: 'center', lg: 'left' },
                    }}
                    gutterBottom
                >
                    Verify your email to further proceed to your account
                </Typography>

                <Box sx={{ marginBottom: 3 }}>
                    <Typography
                        fontWeight={'medium'}
                        sx={{
                            color: 'var(--textColor)',
                            textAlign: { xs: 'center', lg: 'left' },
                        }}
                        variant="h6"
                    >
                        To activate your account, please verify your email
                        address. Simply click the “Send Email Verification”
                        button, and we'll send a verification link to your
                        inbox. Follow the link in the email to complete the
                        activation process and start using your account.
                    </Typography>

                    {/* <Typography
                        fontWeight={'medium'}
                        sx={{
                            my: '20px',
                            color: 'var(--textColor)',
                            textAlign: { xs: 'center', lg: 'left' },
                        }}
                        variant="h6"
                    >
                        If for some reason email is not received in your inbox,
                        please check your Junk or Spam folder, or&nbsp;
                        {resendActivationLoading ? (
                            <span
                                style={{
                                    color: 'var(--primary-color)',
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                request sending...
                            </span>
                        ) : (
                            <a
                                style={{
                                    color: 'var(--primary-color)',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap',
                                }}
                                onClick={resendActivation}
                            >
                                click on the resend button
                            </a>
                        )}
                    </Typography> */}

                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                            width: '100%',
                            maxWidth: '32rem',
                            marginTop: 2,
                            borderRadius: '28px',
                            backgroundColor: '#005699',
                            height: '48px',
                            fontSize: '1rem',
                            fontWeight: 600,
                            '&:hover': {
                                backgroundColor: '#004080',
                            },
                        }}
                        aria-label="Resend Email"
                        size="large"
                        onClick={() => sendActivation()}
                        disabled={sendActivationLoading}
                    >
                        {sendActivationLoading ? (
                            <span
                                style={{
                                    color: 'var(--primary-color)',
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                request sending...
                            </span>
                        ) : (
                            <>Send Email Verification</>
                        )}
                    </Button>
                </Box>
            </Box>

            {/* Social Media Logos - Hidden on mobile */}
            <Box
                sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                    marginTop: 4,
                    justifyContent: 'space-around',
                    gap: 2,
                    width: '100%',
                    // maxWidth: '32rem',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#EFF5FD',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        height: '80px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img src={buildLink} alt="logo" style={{ width: '7rem' }} />
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#EFF5FD',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        height: '80px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={buildStudio}
                        alt="logo"
                        style={{ width: '7rem' }}
                    />
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#EFF5FD',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        height: '80px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img src={buildBid} alt="logo" style={{ width: '7rem' }} />
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#EFF5FD',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        height: '80px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={linksurance}
                        alt="logo"
                        style={{ width: '7rem' }}
                    />
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#EFF5FD',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        height: '80px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img src={buildVid} alt="logo" style={{ width: '7rem' }} />
                </Box>
            </Box>
        </Box>
    )
}

export default Verification
